module.exports = __webpack_public_path__ + "static/img/jxjllogo.b403fbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jxjllogo.png
// module id = sh1s
// module chunks = 1